import React from "react";
import { Rnd } from "react-rnd";
import GuidLines from "../../Pages/GuidLines";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorCanvasOverlays = () => {
  const {
    selectedComponent,
    verticalLineFor,
    isMultiSelectComponentVisible,
    playPause,
    multiSelectedComponent,
    canvasDimension,
  } = useEditorMainPageContext();

  return (
    <>
      {selectedComponent?.componentStyles?.top ? (
        <GuidLines verticalLineFor={verticalLineFor} />
      ) : (
        ""
      )}
      {isMultiSelectComponentVisible() && (
        <div>
          <Rnd
            className="selectedComp"
            disableResizing={true}
            resizeHandleClasses={{
              topRight: "multiTopAnchorRight",
              topLeft: "multiTopAnchorLeft",
              bottomLeft: "multiBottomAnchorLeft",
              bottomRight: "multiBottomAnchorRight",
              top: "multiHorizontalAnchorCenter",
              bottom: "multiHorizontalAnchorCenter",
              left: "multiVerticallAnchorCenter",
              right: "multiVerticallAnchorCenter",
            }}
            style={{
              pointerEvents: !playPause.animationCompleted && "none",
            }}
            size={{
              width: multiSelectedComponent.width,
              height: multiSelectedComponent.height,
            }}
            position={{
              x: multiSelectedComponent.left,
              y: multiSelectedComponent.top,
            }}
            scale={canvasDimension.scale}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderColor: "blue",
              }}
            ></div>
          </Rnd>
        </div>
      )}
    </>
  );
};
